import { ServiceRequestContext } from '@/context/serviceRequestContext';
import { CheckBox } from '@/globalComponents/checkBox';
import InputBox from '@/globalComponents/inputBox';
import TextArea from '@/globalComponents/textArea';
import React, { useContext, useEffect, useState } from 'react';
import { address } from '../SubPages/ServiceRequest';
import styles from './style.module.scss';
import Select, { StylesConfig } from 'react-select';
import { states } from './states';
import ButtonWithLoader from '@/globalComponents/buttonWithLoader';
import { AppScreens, WebEngageEventData } from '@/types/wegengage';
import { WebEngageContext } from '@/context/webengageContext';
import WebEngageUtils from '@/utils/webengageUtils';
import { ProductContext } from '@/context/productContext';
import { WebEngageEventNames } from '../../../types/wegengage';
import { combineAddressFields } from '@/utils/address';
import { capitalize, removeTrailingComma } from '@/utils/string';
import AppBar from '@/shared/AppBar';

export const ReinstallForm = (props: { defaultAddress: address }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  const defaultAddress = props.defaultAddress;
  const lableClassNames = `text-base font-normal md:text-base ${styles.reinstllFormHeadingText}`;
  const valueClassNames = `font-medium text-base md:mt-2.5 mt-1 mb-4 h-12 md:!m-0 md:h-10 ${styles.reinstllFormHeadingText}`;
  const [active, setActive] = useState(false);
  const { state: serviceState, dispatch: serviceAction } = useContext(ServiceRequestContext);

  const initialDefaultAddress = removeTrailingComma(combineAddressFields(defaultAddress));

  const { address, useCurrentAddress, webengageData } = serviceState;
  const { serviceType, serviceReqHistoryData } = serviceState;
  const [isLoading, setIsLoading] = useState(false);
  const { state: webengageState } = useContext(WebEngageContext);
  const { state: productState } = useContext(ProductContext);
  const { selectedProduct } = productState;
  const { openRequests } = serviceReqHistoryData;

  const handleChange = (event: any) => {
    serviceAction.updateUseCurrentAddress(event.target.checked);
    serviceAction.updateAddress(
      event.target.checked
        ? {
            address1: initialDefaultAddress,
            city: defaultAddress.city,
            state: defaultAddress.state,
            postal_code: defaultAddress.postal_code + '',
          }
        : { address1: '', city: '', state: '', postal_code: '' },
    );
  };

  const handleInputChange = (e: any) => {
    const value =
      e.target.id === 'postal_code' || e.target.id === 'address1'
        ? e.target.value
        : e.target.value.replace(/[^a-z | ' ']/gi, '');
    serviceAction.updateAddress({ ...address, [e.target.id]: value });
  };

  const submitAddress = () => {
    serviceAction.updateAddress(address);
    serviceAction.changeComponent('bookASlot');
  };

  const customStyles: StylesConfig = {
    clearIndicator: (baseStyles) => ({
      ...baseStyles,
      display: 'none',
    }),
    dropdownIndicator: (baseStyles) => ({
      ...baseStyles,
      strokeWidth: '2px',
      color: '#4E9BFF',
    }),
    indicatorSeparator: (baseStyles) => ({
      ...baseStyles,
      display: 'none',
    }),
    control: (baseStyles) => ({
      ...baseStyles,
      height: '40px',
      border: '1px solid rgb(209, 213, 219)',
      borderRadius: '8px',
      boxShadow: `${active ? 'none' : ''}`,
      borderColor: `${active ? 'none' : ''}`,
      ':hover': {
        borderColor: 'rgb(209, 213, 219)',
      },
      '@media (max-width: 768px)': {
        height: '48px',
      },
    }),
    option: (baseStyles, { isSelected }) => ({
      ...baseStyles,
      ':hover': {
        backgroundColor: '#353a3f',
        color: '#fff',
      },
      backgroundColor: `${isSelected ? '#353a3f' : ''} `,
      color: `${isSelected ? '#353a3f' : ''} `,
    }),
  };

  const validateAddress = () => {
    return (
      address.city !== '' &&
      address.state !== '' &&
      address.postal_code !== '' &&
      (address.postal_code + '').length >= 6 &&
      address.address1 !== undefined &&
      address.address1 !== ''
    );
  };

  const _webengageObj: WebEngageEventData = {
    ...webengageState.webengageDefault,
    navigated_from: AppScreens.REINSTALL_SCREEN,
    customer_type: WebEngageUtils.stringUtil(selectedProduct?.expiryStatus?.status),
    mandatory_service_open: webengageData.mandatory_service_open,
    service_request_open: WebEngageUtils.returnBoolString(openRequests?.length > 0),
    scheduling_automation_flow: 'Yes',
    product_selected: WebEngageUtils.stringUtil(selectedProduct?.name),
    product_id: WebEngageUtils.stringUtil(selectedProduct?.id),
    service_type: serviceType,
  };

  useEffect(() => {
    const _we = window.webengage;
    if (_we) {
      _we.track(WebEngageEventNames.REINSTALL_SCREEN_OPENED, _webengageObj);
    }
  });

  return (
    <div className="flex flex-col -mt-8">
      <section className="md:flex flex-col md:w-[80%] md:mx-auto">
        <AppBar
          transparent
          fixed
          label="Reinstall Form"
          onClick={() => {
            serviceAction.changeComponent('bookAService');
          }}
        />
        <h1 className="text-lg pb-4 pt-16 font-bold md:text-xl md:leading-[2.6rem] text-[#333333] mt-4 md:mt-8">
          Where would you like the device to be re-installed?
        </h1>
        <CheckBox
          id={'currentLocation'}
          checked={useCurrentAddress}
          label={
            <p
              className={`pl-4 pb-1.5 mb-4 text-sm font-normal md:text-base	 ${styles.reinstllFormText}`}
            >
              Use current address
            </p>
          }
          classNames="mb-4 "
          onChange={() => handleChange(event)}
          disabled={defaultAddress === null ? true : false}
        />
        <label htmlFor="address1" className={lableClassNames}>
          New Address
        </label>
        <TextArea
          id={'address1'}
          maxLength={500}
          className={`!h-28 !border md:!h-20 resize-none ${valueClassNames}`}
          value={address.address1}
          onChange={() => handleInputChange(event)}
          required
        />
        <div className="md:grid md:grid-cols-2 md:gap-y-6 md:gap-x-24 md:mt-7 ">
          <div>
            <label htmlFor="city" className={lableClassNames}>
              City
            </label>
            <InputBox
              id={'city'}
              classNames={valueClassNames}
              value={capitalize(address.city)}
              onChange={() => handleInputChange(event)}
              type="text"
              required
            />
          </div>
          <div>
            <label htmlFor={'state'} className={lableClassNames}>
              State
            </label>
            <Select
              inputId="state"
              required
              className={valueClassNames}
              onFocus={() => {
                setActive(true);
              }}
              onBlur={() => {
                setActive(true);
              }}
              options={states}
              name="States"
              isClearable
              value={{ value: capitalize(address.state), label: capitalize(address.state) }}
              onChange={(e: any) => {
                serviceAction.updateAddress({ ...address, state: e.label });
              }}
              styles={customStyles}
            />
          </div>
          <div className="mb-14 md:mb-18">
            <label htmlFor="postal_code" className={lableClassNames}>
              Pincode
            </label>
            <InputBox
              id={'postal_code'}
              classNames={valueClassNames}
              value={capitalize(address.postal_code + '')}
              onChange={() => handleInputChange(event)}
              type="number"
              maxLength={6}
              minLength={6}
              required
            />
          </div>
        </div>
      </section>
      <ButtonWithLoader
        classNames="w-full text-sm md:w-1/5 md:self-end grid place-content-center"
        variant="primary"
        isLoading={isLoading}
        onClick={() => {
          setIsLoading(true);
          submitAddress();
          setIsLoading(false);
          const _we = window.webengage;
          if (_we) {
            _we.track(WebEngageEventNames.REINSTALL_SCREEN_NEXT_CLICKED, {
              ..._webengageObj,
              user_current_address_checkbox: useCurrentAddress ? 'Checked' : 'Unchecked',
            });
          }
        }}
        dataTestId="r-address-next-button"
        disabled={!validateAddress()}
      >
        NEXT
      </ButtonWithLoader>
    </div>
  );
};
